/**
 * @generated SignedSource<<44d4de4b131dea86aa2cdb26aa2eb4ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ForgotPasswordQuery$variables = Record<PropertyKey, never>;
export type ForgotPasswordQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ForgotPassword_query">;
};
export type ForgotPasswordQuery = {
  response: ForgotPasswordQuery$data;
  variables: ForgotPasswordQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ForgotPasswordQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ForgotPassword_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ForgotPasswordQuery",
    "selections": [
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "fitIn",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": "url(fitIn:true)"
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b9b1d7592477d5b6cec2cba61531d88",
    "id": null,
    "metadata": {},
    "name": "ForgotPasswordQuery",
    "operationKind": "query",
    "text": "query ForgotPasswordQuery {\n  ...ForgotPassword_query\n}\n\nfragment CompanyLogo_company on Company {\n  nameFriendly\n  logo {\n    url(fitIn: true)\n    id\n  }\n}\n\nfragment ForgotPassword_query on Query {\n  company: companyDomainName {\n    id\n    ...CompanyLogo_company\n  }\n}\n"
  }
};
})();

(node as any).hash = "779d557b9fcf9b4a34e5ffbeece5cf05";

export default node;
